export const COMP_PIN_PATH =
  'M9.5 0.5C14.4507 0.5 18.5 4.69414 18.5 9.91309C18.5 12.4863 17.3282 14.725 15.5479 16.9355C13.8463 19.0481 11.6687 21.0489 9.5 23.2822C7.3313 21.0489 5.1537 19.0481 3.45215 16.9355C1.67179 14.725 0.500013 12.4863 0.5 9.91309C0.5 4.69414 4.54928 0.5 9.5 0.5Z';
